import {useEffect, useState} from "react";
import {apiClient} from "../providers/apiClient";

const FILTERS_DEFAULT = {
    orderBy: null,
    orderDirection: null,
    pageSize: 6,
    pageNumber: 1,
}

const fetchConsumers = (params) => {
    return apiClient.get("/api/Account/list", {params});
}

const useConsumers = (initialFilters) => {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState({...FILTERS_DEFAULT, ...initialFilters});
    const [pagination, setPagination] = useState({ hasNext: false, hasPrevious: false, pageSize: 6, pageNumber: 1});
    const nextPage = () => {
        if(!pagination.hasNext) return;

        setFilter("pageNumber", pagination.pageNumber + 1);
    }

    const previousPage = () => {
        if(!pagination.hasPrevious) return;

        setFilter("pageNumber", pagination.pageNumber - 1);
    }

    const setDefaultFilters = () => {
        setFilters({...FILTERS_DEFAULT});
    }

    const refresh = () => {
        fetchConsumers({...filters, isConsumer: true}).then(response => {
            const data = response.data;
            setData(data.items);
            setPagination({
                hasNext: data.hasNext,
                hasPrevious: data.hasPrevious,
                pageNumber: filters.pageNumber,
                pageSize: filters.pageSize
            });
        }).catch(e => {
            setError(e.message);
        }).finally(() => {
            setLoading(false)
        });
    }

    useEffect(() => {
        setLoading(true);

        fetchConsumers({...filters, isConsumer: true}).then(response => {
            const data = response.data;
            setData(data.items);

            setPagination(prev => ({
                pageSize: filters.pageSize,
                pageNumber: filters.pageNumber,
                hasNext: data.hasNext,
                hasPrevious: data.hasPrevious,
            }));

        }).catch(e => {
            setError(e.message);
        }).finally(() => {
            setLoading(false)
        });

    }, [filters]);

    const setFilter = (filterName, value) => {
        setFilters(prev => {
            return {
                ...prev,
                [filterName]: value
            }
        })
    }


    return {
        data,
        error,
        pagination,
        loading,
        setFilter,
        filter: filters,
        nextPage,
        previousPage,
        refresh,
        setDefaultFilters
    }
}

export default useConsumers;